import React from "react";

const WebPages_Helpers = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Helpers</h1>
      <p>This is the WebPages Helpers page content.</p>
    </div>
  );
};

export default WebPages_Helpers;
